
import HomeView from "../views/home/index.vue";

export const routes = [
    {
        path: "/",
        redirect: "/enterpriseList",
    },
    //企业概况
    {
        path: "/home",
        name: "Home",
        component: () => import(/* webpackChunkName: "productList" */ "../views/home/index.vue"),
    },
    //产品列表页
    {
        path: "/productList",
        name: "ProductList",
        component: () => import(/* webpackChunkName: "productList" */ "../views/productList/index.vue"),
    },
    //搜索落地页
    {
        path: "/searchList",
        name: "SearchList",
        component: () => import(/* webpackChunkName: "productList" */ "../views/searchList/index.vue"),
    },
    //联系我们
    {
        path: "/contact",
        name: "Contact",
        component: () => import(/* webpackChunkName: "contact" */ "../views/contact/index.vue"),
    },
    //工程案例
    {
        path: "/case",
        name: "Case",
        component: () => import(/* webpackChunkName: "case" */ "../views/case/index.vue"),
    },
    //中标信息
    {
        path: "/information",
        name: "Information",
        component: () => import(/* webpackChunkName: "information" */ "../views/information/index.vue"),
    },
    //综合评价
    {
        path: "/evaluation",
        name: "Evaluation",
        component: () => import(/* webpackChunkName: "evaluation" */ "../views/evaluation/index.vue"),
    },
    //产品详情
    {
        path: "/productDetail",
        name: "ProductDetail",
        redirect: "/productDetail/details",
        component: () => import(/* webpackChunkName: "productDetail" */ "../views/productDetail/index.vue"),
        children: [
            {
                path: "details",
                name: "Details",
                component: () =>
                    import(/* webpackChunkName: "userchunks"  */ "@/views/productDetail/components/productDetail/index.vue"),
            },
            {
                path: "specification",
                name: "Specification",
                component: () =>
                    import(/* webpackChunkName: "userchunks"  */ "@/views/productDetail/components/specification/index.vue"),
            },
            {
                path: "report",
                name: "Report",
                component: () =>
                    import(/* webpackChunkName: "userchunks"  */ "@/views/productDetail/components/productReport/index.vue"),
            },
        ],
    },
    {
        path: "/enterpriseList",
        name: "enterpriseList",
        component: () => import(/* webpackChunkName: "productDetail" */ "../views/enterpriseList/index.vue"),
    },
    {
        path: "/:catchAll(.*)",
        name: "404",
        component: () => import(/* webpackChunkName: "productDetail" */ "../views/productDetail/index.vue"),
    },
];
